import { Outlet } from "react-router-dom";
import {
  Layout,
  LayoutHeader,
  LayoutContent,
} from "@jana-technology/platform-ui";

import { NavbarContainer, SystemOverviewNavTabs } from "components/navbar";
import { OverviewAssetSelection } from "components/sidebar";

export const SystemOverviewLayout = () => {
  return (
    <Layout>
      <LayoutHeader>
        <NavbarContainer>
          <SystemOverviewNavTabs />
        </NavbarContainer>
      </LayoutHeader>
      <LayoutContent sidebar={<OverviewAssetSelection />} sidebarSize="sm">
        <Outlet />
      </LayoutContent>
    </Layout>
  );
};

export default SystemOverviewLayout;
